export type NativeNotificationPayload = {
  notificationId: string;
  source: "background_tap" | "foreground_receive" | "terminated_tap";
  receivedAt: string;
  data: Record<string, string>;
  title: string;
  body: string;
  messageId?: string;
  type?: string;
  deepLink?: string;
};

declare global {
  interface WindowEventMap {
    nativeNotificationReceived: CustomEvent<NativeNotificationPayload>;
  }
}

export function isUserTap(source: NativeNotificationPayload["source"]): boolean {
  return source === "background_tap" || source === "terminated_tap";
}

export function subscribeNativeNotification(onNotification: (payload: NativeNotificationPayload) => void): () => void {
  const handler = (event: CustomEvent<NativeNotificationPayload>) => {
    if (!event.detail?.notificationId) return;
    onNotification(event.detail);
  };

  window.addEventListener("nativeNotificationReceived", handler);
  return () => window.removeEventListener("nativeNotificationReceived", handler);
}
